import React from 'react';
import { useRouter } from '~/hooks';

const SubmissionConfirmation = () => {
    const { replace } = useRouter();
    return (
        <div className="h-full w-full flex flex-col items-center justify-center p-8">
            <h1 className="text-4xl text-blue-60 font-bold mb-2">We&apos;re on it!</h1>
            <p className="leading-8 text-lg">Thank you for submitting your title opinion with us.</p>
            <p className="leading-8 text-lg">A copy of your order will be sent to your email address.</p>
            <button
                className="rounded-full py-3 px-5 text-white bg-blue-50 my-4 focus:outline-none"
                onClick={() => {
                    replace('/');
                }}
            >
                Okay
            </button>
        </div>
    );
};

export default SubmissionConfirmation;